<template>
  <v-col cols="12">
    <gg-card>
      <gg-card-header>
        Pending Access
      </gg-card-header>
      <gg-card-text>
        <v-data-table :headers="headersPending"
                      :items="accessPendingList"
                      :loading="!loaded">
          <v-progress-linear slot="progress" color="green" height="2" indeterminate />
          <template v-slot:item.email="{ item }">
            <div><b>{{ item.name }}</b></div>
            <div>{{ item.email }}</div>
          </template>
          <template v-slot:item.service_name="{ item }">
            <router-link v-if="link(item.service_id)" :to="link(item.service_id)">
              {{ item.service_name }}
            </router-link>
            <span v-else>
                {{ item.service_name }}
              </span>
          </template>
          <template v-slot:item.id="{ item }">
            <template v-if="item.type === 'received'">
              <gg-btn text class="my-0" @click="openPendingActionDialog(item.id, pendingActionsTypes.accept)">
                Accept
                <span class="visually-hidden text-lowercase">button</span>
              </gg-btn>
              <gg-btn text class="my-0" @click="openPendingActionDialog(item.id, pendingActionsTypes.reject)">
                Reject
                <span class="visually-hidden text-lowercase">button</span>
              </gg-btn>
            </template>
            <template v-else>
              <gg-btn text class="my-0" @click="openPendingActionDialog(item.id, pendingActionsTypes.resend)">
                Resend
                <span class="visually-hidden text-lowercase">button</span>
              </gg-btn>
              <gg-btn text class="my-0" @click="openPendingActionDialog(item.id, pendingActionsTypes.revoke)">
                Revoke
                <span class="visually-hidden text-lowercase">button</span>
              </gg-btn>
            </template>
          </template>
        </v-data-table>
      </gg-card-text>
    </gg-card>

    <!-- Revoke/Reject -->
    <pending-action-modal :opened="pendingActionDialog"
                          :action-type="pendingActionType"
                          :id="selectedPendingId"
                          @close="closePendingActionDialog" />
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PendingActionsTypes from '@/helpers/profile-access'
import PendingActionModal from 'Components/Profile/Access/Pending/PendingActionModal'
import { link } from 'Helpers/profile-access'

export default {
  name: 'PendingAccess',
  components: {
    PendingActionModal,
  },
  data: () => ({
    headersPending: [
      {
        text: 'Email',
        value: 'email',
      },
      {
        text: 'Service',
        value: 'service_name',
      },
      // {
      //   text: 'Service Type',
      //   value: 'service_type',
      // },
      {
        text: 'Actions',
        value: 'id'
      },
    ],
    loaded: false,
    pendingActionsTypes: PendingActionsTypes,
    pendingActionDialog: false,
    pendingActionType: '',
    selectedPendingId: '',
  }),
  computed: {
    ...mapGetters(['accessPendingList', 'services']),
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions(['reportError', 'getAccessList', 'getAccountList']),
    async loadData () {
      this.loaded = false
      try {
        await this.getAccessList()
      } catch (e) {
        this.reportError(e)
      }
      this.loaded = true
    },
    link,
    openPendingActionDialog (invitationId, actionType) {
      this.selectedPendingId = invitationId
      this.pendingActionType = actionType
      this.pendingActionDialog = true
    },
    closePendingActionDialog () {
      this.selectedPendingId = ''
      this.pendingActionType = ''
      this.pendingActionDialog = false
    },
  }
}
</script>
